module.exports = __webpack_public_path__ + "static/media/icon_auditoria.ce5e6dbc.png";